import { useUrlParamSync } from "./useUrlParamSync";

// Specialized hook for components that check mf/tcf parameters
export const useUrlParamSyncWithFilters = <T extends string = string>(
  validValues: readonly T[],
  defaultValue: T,
  paramName: string = "vb"
) => {
  return {
    ...useUrlParamSync<T>({
      paramName,
      validValues,
      defaultValue
    })
  };
};
